import type { Generation } from '@/api/types';

export type Group = { label: string; items: Generation[] };

const DAY_MS = 24 * 60 * 60 * 1000;

function startOfDay(d: Date): number {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}

function fmt(ts: Date, todayStart: number): string {
  const t = startOfDay(ts);
  if (t === todayStart) return 'Сегодня';
  if (t === todayStart - DAY_MS) return 'Вчера';
  return ts.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long' });
}

export function groupByDay(items: Generation[], now = new Date()): Group[] {
  const todayStart = startOfDay(now);
  const out: Group[] = [];
  let current: Group | null = null;
  for (const g of items) {
    const ts = new Date(g.created_at);
    const label = fmt(ts, todayStart);
    if (!current || current.label !== label) {
      current = { label, items: [] };
      out.push(current);
    }
    current.items.push(g);
  }
  return out;
}
